module.exports = __webpack_public_path__ + "static/14-7ad5fd7c60ef10f044e42cc889eab1f1.png";